<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.employerSettings_header | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
  <mat-divider class="section-header-underline"></mat-divider>
</div>

<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <app-input-field
        [control]="this.form.controls.companyName"
        [icon]="'business'"
        [label]="data.sysText.companyName_Title"
        [group]="form"
      ></app-input-field>
      <div class="domainName">
        <app-input-field class="inputWidth"
          [control]="this.form.controls.subdomainName"
          [icon]="'language'"
          [label]="data.sysText.subdomainName_Title"
          [group]="form"
          [patternError]="data.sysText.subdomainNameError"
          [info]="data.sysText.subdomainNameError"
          [msErrorKey]="'subdomainName'"
          [customMsError]="(data.erProfile.modelStateErrors.hasOwnProperty('subdomainName') ? ((data.sysText.subdomainName_Title | titlecase) + ' ' + data.sysText.required) : null)">
        </app-input-field>
        <p class="body1">{{ data.erProfile.stiiraDomain}}</p>
      </div>

      <div class="dialog--section">
        <mat-icon class="field-icon">image</mat-icon><p class="grey1">{{ data.sysText.employerLogo_Title | titlecase }}</p>
        <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
          [matTooltip]="data.sysText.logoUploadInfo"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      </div>

      <div class="logo-upload-section">
        @if (logoChangedEvent || setEmployerLogo) {
          <div class="pad">
            <div class="file-name-container">
              <mat-icon class="fill4-dk">check</mat-icon>
              <div>
                <span class="body2 side-space grey3">{{ employerLogo.value }}</span>
              </div>
              <button type="button" class="button-reset" [attr.aria-label]="data.sysText.removeFile_ariaLabel" (click)="clearFile()">
                <mat-icon class="black-inactive small pointer">clear</mat-icon>
              </button>
            </div>
            <div>
              <image-cropper
                id="logo-cropper"
                [imageChangedEvent]="logoChangedEvent"
                [resizeToWidth]="500"
                [resizeToHeight]="500"
                [onlyScaleDown]="true"
                [maintainAspectRatio]="false"
                [disabled]="true"
                [imageBase64]="setEmployerLogo"
                [cropperFrameAriaLabel]="data.sysText.employerLogo_Title | titlecase"
                [alignImage]="'left'"
                output="base64"
                format="png"
                (imageCropped)="getEmployerLogo($event)"
                (cropperReady)="onLogoCropperReady()"
                (loadImageFailed)="loadImageFailed()">
              </image-cropper>
            </div>
            <div aria-live="polite">
              @if (employerLogo.errors?.msError) {
                <mat-error class="mse-form-error caption bottom-hint">{{ employerLogo.errors?.msError }}</mat-error>
              }
            </div>
          </div>
        } @else {
          <input hidden type="file" accept="image/*" #imgFileInput (change)="logoChangeEvent($event)" autocomplete="off"/>
          <button
            #uploadButton
            type="button"
            mat-stroked-button
            class="button"
            color="accent"
            (click)="imgFileInput.click()">
            {{ data.sysText.uploadLogo }}
          </button>
        }
      </div>

      <app-input-field
        [control]="this.form.controls.headcount"
        [icon]="'people'"
        [label]="data.sysText.headcountTotal_Title"
        [group]="form"
        [inputType]="'number'"
        [msErrorKey]="'headcount'"
        [customMsError]="(data.erProfile.modelStateErrors.hasOwnProperty('headcount') ? ((data.sysText.headcountTotal_Title | titlecase) + ' ' + data.sysText.required) : null)">
      </app-input-field>
      <div class="dialog--section">
        <mat-icon class="field-icon">tune</mat-icon><p class="grey1">{{ data.sysText.accessSettings_Section | titlecase }}</p>
      </div>
      <div class="toggle--section">
        @if (this.data.erProfile.showAllowAccess) {
          <app-slide-toggle
            [control]="this.form.controls.allowAccess"
            [label]="data.sysText.employerAccess_info"
            [checked]="this.data.erProfile.allowAccess">
          </app-slide-toggle>
        }
        <div class="bottom-row">
          <app-slide-toggle
            [control]="this.form.controls.allowNewLeaves"
            [label]="data.sysText.allowNewLeaves_info"
            [checked]="this.data.erProfile.allowNewLeaves">
          </app-slide-toggle>
        </div>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>


